import { render, staticRenderFns } from "./salesorderbybrand.vue?vue&type=template&id=851af2fc"
import script from "./salesorderbybrand.vue?vue&type=script&lang=js"
export * from "./salesorderbybrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports